/* eslint-disable max-params */
/* eslint-disable complexity */
/**
 * 日视图
 */

import React, { useMemo, useRef, useEffect, useState, useCallback } from "react";
import TimeLine from "@/components/Calendars/View/common/TimeLine";
import "./index.less";
import "../dragMouse/index.less";
import { getComputedElements, getColor } from "../../utils/ComputedElement";
import ViewScheduleItem from "../common/ScheduleItem";
import ViewTaskItem from "../common/TaskItem";
import {
  Schedule,
  addSchedule,
  User,
  quickModifyNewSchedule,
  ModifyType,
  quickSchedule,
  Agent,
  UserType,
  getScheduleInfo
} from "@/api/calendar";
import { scheduleTypeList } from "./../../ScheduleTypeSelect";
import bus from "@/utils/bus";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import { useInitScrollView, useHandleScale } from "../common/Hook";
import { connect } from "dvajs";
import ScaleComp from "@/components/Calendars/View/common/Scale";
import { DayViewAlldayComp } from "../common/AllDayComp";
import QuickCreateModal from "../common/QuickCreateModal";
import ScrollView from "react-custom-scrollbars";
import { useRefreshCurrentTime } from "../../myHooks";
import { analysisLog } from "@/utils/logAnalytics";
import { throttle } from "lodash";
import { Modal, message } from "antd";
import { DragType, DragViewType, DragState, TriggerType } from "../../Enums";
import {
  handleMouseDownFun,
  handleMouseMoveFun,
  handleMouseUpFun,
  handleScrollFrameFun,
  pauseEvent
} from "../dragMouse/mouseEvent";
import BaseButton from "../../Button";
import BasicModal from "../../Modal/BasicModal";
import { UserModel } from "@/models/user";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import { getNetCheckUrl } from "@/config/config";
import { parsingMeetingInfo } from "@/components/Calendars/utils";
import { FocusSDK } from "@/utils";

// const onScroll = (e: any) => {
//   if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
//     // 滚动到底部需要做的事情
//   }
// };

function mapStateToProps({ calendar, user }: any) {
  return {
    percent: calendar.dayViewScalePercent,
    selectedTime: calendar.selectedTime,
    userData: user.userData.user
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateModal(data: any) {
      dispatch({ type: "calendar/openCreateModal", payload: data });
    }
  };
}

export function CurrentLine({
  current,
  showCircle = false,
  top
}: {
  current: Dayjs;
  showCircle?: boolean;
  top: number;
}) {
  const style = {
    top: top + "px"
  };
  const today = current.isToday();
  return (
    <div className="calendar-dayview-currentline" style={style}>
      {today && showCircle && <div className="calendar-dayview-currentline-today" />}
    </div>
  );
}

function DayView({
  current,
  data,
  percent,
  onCreate,
  myCalendar,
  userData,
  selectedTime,
  openCreateModal
}: {
  current: Dayjs;
  data: Schedule[];
  userData: UserModel;
  percent: number;
  selectedTime: any;
  onCreate: (time: Dayjs) => void;
  openCreateModal: (data: any) => void;
  myCalendar: any;
}) {
  const { t } = useTranslation("calendar");
  const currentTimeObj = useRefreshCurrentTime();
  const list = useMemo(() => {
    // return data.filter((d) => Number(d.isAlldate) !== 1);
    return data.filter(
      (d) =>
        Number(d.isAcross) !== 1 &&
        Number(d.isAlldate) !== 1 &&
        !(
          dayjs(d.scheduleBeginTime).format("HH:mm") === "00:00" &&
          (dayjs(d.scheduleEndTime).format("HH:mm") === "00:00" ||
            dayjs(d.scheduleEndTime).format("HH:mm") === "23:59")
        )
    );
  }, [data]);
  const alldayList = useMemo(() => {
    // return data.filter((d) => Number(d.isAlldate) === 1);
    return data.filter(
      (d) =>
        Number(d.isAcross) === 1 ||
        Number(d.isAlldate) === 1 ||
        (dayjs(d.scheduleBeginTime).format("HH:mm") === "00:00" &&
          (dayjs(d.scheduleEndTime).format("HH:mm") === "00:00" ||
            dayjs(d.scheduleEndTime).format("HH:mm") === "23:59"))
    );
  }, [data]);
  const height = useHandleScale(percent);
  const divEl = useInitScrollView();
  const scrollRef: any = useRef(null);
  const dataRef = useRef({
    scrollUpTimer: null as any,
    scrollDownTimer: null as any,
    curDayIdx: -1,
    curDayStartTime: dayjs(),
    originCilentHeight: 0,
    originScrollHeight: 0,
    container: null as any,
    containerHeight: 0,
    minHeight: 0,
    minUnitHeight: 0,
    isMouseDown: false,
    mouseY: 0,
    dragDivHeight: 0,
    scrollTop: 0,
    originScrollTop: 0,
    dragStartTop: 0,
    isUnderOrigin: true,
    commonOffsetTop: 149,
    curDragType: DragType.DRAGCREATE,
    curMoveSchedule: null as Schedule | null,
    dragDom: null as any
  });
  const [quickCreateModalVisible, setQuickCreateModalVisible] = useState(0); // 0隐藏 1显示mouseup 2显示dblclick 3显示未定义
  const [quickCreateModalTop, setQuickCreateModalTop] = useState(0);
  const [quickCreateModalLeft, setQuickCreateModalLeft] = useState(0);
  const [dragCreateBeginTime, setDragCreateBeginTime]: any = useState(null);
  const [dragCreateEndTime, setDragCreateEndTime]: any = useState(null);
  const [dragCreateTitle, setDragCreateTitle]: any = useState("");
  // 修改或删除日程确认弹窗
  const [dragModifySchedule, setDragModifySchedule] = useState({
    triggerType: TriggerType.DOUBLE,
    modalVisible: false,
    modifyBeginTime: dayjs().valueOf(),
    modifyEndTime: dayjs().valueOf()
  });
  const hasMessage = useRef(false); // 是否已经显示了不允许拖拽的提示false没有true有
  useEffect(() => {
    setTimeout(() => {
      if (scrollRef) {
        if (scrollRef.current) {
          const sHeigh = scrollRef.current?.getScrollHeight();
          const sTop = scrollRef.current?.getScrollTop();
          const cHeight = scrollRef.current?.getClientHeight();
          if (currentTimeObj.top > sHeigh - cHeight) {
            scrollRef.current?.scrollToBottom();
            dataRef.current.scrollTop = sHeigh - cHeight;
          } else if (currentTimeObj.top < cHeight / 2) {
            scrollRef.current?.scrollToTop();
            dataRef.current.scrollTop = 0;
          } else {
            scrollRef.current?.scrollTop(currentTimeObj.top - cHeight / 4);
            dataRef.current.scrollTop = currentTimeObj.top - cHeight / 4;
          }
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getElLeft = useCallback((e: any) => {
    let offset = e.offsetLeft;
    if (e.offsetParent) offset += getElLeft(e.offsetParent);
    return offset;
  }, []);
  const reloadSchedule = () => {
    bus.emit("calendar:reloadSchedule");
  };
  const throttleHandleDragElementResize = throttle(() => {
    const { curDragType, container } = dataRef.current;
    if (curDragType === DragType.DRAGCREATE) {
      // if (!quickCreateModalVisible) return;
      if (container) {
        // 设置快速创建弹窗左右位置
        setQuickCreateModalTop(document.documentElement.offsetHeight / 2);
        // 设置快速创建弹窗左右位置 180是modal的宽度的一半
        setQuickCreateModalLeft(getElLeft(container) + container.offsetWidth / 2 - 180);
      }
    }
  }, 50);
  // 通过位置计算时间
  const calculateTimeByY = (cu: any, clientY: number) => {
    // const scrollHeight = cu.scrollHeight;
    // const containerRect: any = cu.getBoundingClientRect();
    // const cuOffsetTop = containerRect?.y + dataRef.current.scrollTop;
    // const position = clientY + dataRef.current.scrollTop - cuOffsetTop;
    // const count =
    //   Math.floor(((Math.round((position / scrollHeight) * 100) / 100) * 60 * 24) / 15) * 15;
    const top = cu.parentNode.scrollTop;
    const offset = cu.parentNode.parentNode.offsetTop;
    const scrollHeight = cu.scrollHeight;
    const container: any = document.querySelector(".appContent");
    let containerTop = 0;
    if (container) {
      containerTop = container.offsetTop;
    }
    const position = clientY - containerTop - offset + top;
    // const count =
    //   Math.floor(((Math.round((position / scrollHeight) * 100) / 100) * 60 * 24) / 15) * 15;
    const count = Math.round(Math.floor((position / scrollHeight) * 60 * 24) / 15) * 15;
    return current.startOf("date").add(count, "minute");
  };

  function handleViewClick(e: any) {
    const cu: any = divEl.current;
    if (cu) {
      const time = calculateTimeByY(cu, e.clientY);
      onCreate(time);
    }
  }
  function resetDragData() {
    if (dragModifySchedule.modalVisible) {
      setDragModifySchedule({
        ...dragModifySchedule,
        triggerType: TriggerType.DOUBLE,
        modalVisible: false,
        modifyBeginTime: dayjs().valueOf(),
        modifyEndTime: dayjs().valueOf()
      });
    }
    const dragMask: any = document.getElementById("drag-mask");
    dragMask?.click();
  }
  // 快速修改日程
  async function quickModifySchedule(
    triggerType: string,
    modifyType: number,
    beginTime: number,
    endTime: number
  ) {
    const { curMoveSchedule } = dataRef.current;
    if (curMoveSchedule?.scheduleId) {
      if (triggerType === TriggerType.DRAG) {
        // 调用编辑接口
        if (curMoveSchedule.beginTime === beginTime && curMoveSchedule.endTime === endTime) {
          resetDragData();
          return;
        }
        // 如果该日程上存在会议信息 则不允许修改为当前时间之前
        let minfo = parsingMeetingInfo(curMoveSchedule.description);
        if (minfo) {
          if (dayjs(beginTime).isSameOrBefore(dayjs())) {
            message.info(t("do not all appoint before"));
            resetDragData();
            return;
          }
        }
        const quickScheduleData: quickSchedule = {
          calendarId: curMoveSchedule.calendarId,
          scheduleId: curMoveSchedule.scheduleId,
          modifyType: modifyType,
          beginTime: beginTime,
          endTime: endTime,
          beforeBeginTime: curMoveSchedule.scheduleBeginTime?.valueOf(),
          beforeEndTime: curMoveSchedule.scheduleEndTime?.valueOf(),
          repeat: curMoveSchedule.repeat
        };
        const [data, err]: any = await quickModifyNewSchedule(quickScheduleData);
        if (err) {
          message.error(err.message || err);
          resetDragData();
          return;
        }
        // 触发一个事件 告知群组是否需要更新日程详情显示数据
        // bus.emit("chat:group:refreshScheduleInfo");
        reloadSchedule();
        resetDragData();
        message.success(t("modified-successfully"));
      } else if (triggerType === TriggerType.DOUBLE) {
        getScheduleInfo({
          scheduleId: curMoveSchedule.scheduleId
        })
          .then(async (result: Schedule) => {
            if (!result) {
              const netServer = NetworkCheck.getInstance({
                url: getNetCheckUrl(),
                checkType: UseCheckType.API
              });
              const onLine = await netServer.checkNet();
              if (onLine) {
                message.warning(t("schedule is not found"));
              } else {
                message.warning(t("schedule offline view"));
              }
              resetDragData();
              return;
            }
            // 查询日程详情 打开日程编辑抽屉
            openCreateModal({
              content: {
                ...result,
                scheduleId: curMoveSchedule.scheduleId,
                scheduleBeginTime: dayjs(result.beginTime),
                scheduleEndTime: dayjs(result.endTime),
                modifyType: modifyType
              },
              visible: true
            });
            resetDragData();
          })
          .catch((err) => {
            message.error(err?.message?.toString() || t("schedule is not found"));
            resetDragData();
          });
      }
    }
  }
  // 双击日程块 修改日程
  const doubleModifySchedule = (schedule: Schedule) => {
    if (schedule.repeat) {
      setDragModifySchedule({
        ...dragModifySchedule,
        triggerType: TriggerType.DOUBLE,
        modalVisible: true,
        modifyBeginTime: schedule.beginTime,
        modifyEndTime: schedule.endTime
      });
    } else {
      quickModifySchedule(
        TriggerType.DOUBLE,
        ModifyType.Update,
        schedule.beginTime,
        schedule.endTime
      );
    }
  };
  // 拖动计算时间
  const updateDragTime = throttle((ev: any, dragState: string, dragType: number, el: any) => {
    const cu: any = divEl.current;
    if (el && cu) {
      const boxRect = el.getBoundingClientRect();
      let startTime = calculateTimeByY(cu, boxRect?.top);
      let endTime = calculateTimeByY(cu, boxRect?.bottom);
      // 如果结束时间是第二天的00:00 则建减一分钟 拖动不创建跨天日程
      if (endTime.valueOf() === dayjs(current.format("YYYY-MM-DD")).add(1, "day").valueOf()) {
        endTime = endTime.subtract(1, "minute");
      }
      if (dragType === DragType.DRAGCREATE) {
        el.innerText = `新建日程\n${startTime.format("HH:mm")}-${endTime.format("HH:mm")}`;
        if (dragState === DragState.UP) {
          // 调用创建
          let { isUnderOrigin, container } = dataRef.current;
          // 设置快速创建弹窗上下位置
          setQuickCreateModalTop(document.documentElement.offsetHeight / 2);
          // 设置快速创建弹窗左右位置 180是modal的宽度的一半
          setQuickCreateModalLeft(getElLeft(container) + container.offsetWidth / 2 - 180);
          setQuickCreateModalVisible(ev.type === "mouseup" ? 1 : ev.type === "dblclick" ? 2 : 3);
          setDragCreateBeginTime(startTime);
          setDragCreateEndTime(endTime);
        }
      } else if (dragType === DragType.DRAGBLOCKEDIT) {
        const timeEl = el.getElementsByClassName("time")[0];
        if (timeEl) {
          timeEl.innerText = `${startTime.format("HH:mm")}-${endTime.format("HH:mm")}`;
        }
        if (dragState === DragState.UP) {
          const { curMoveSchedule } = dataRef.current;
          if (!curMoveSchedule) return;
          if (curMoveSchedule.repeat) {
            setDragModifySchedule({
              ...dragModifySchedule,
              triggerType: TriggerType.DRAG,
              modalVisible: true,
              modifyBeginTime: startTime.valueOf(),
              modifyEndTime: endTime.valueOf()
            });
          } else {
            Modal.confirm({
              content: t("do you want to modify the schedule time"),
              okText: t("confirm"),
              cancelText: t("cancel"),
              onOk: () => {
                quickModifySchedule(
                  TriggerType.DRAG,
                  ModifyType.Update,
                  startTime.valueOf(),
                  endTime.valueOf()
                );
              },
              onCancel: () => {
                resetDragData();
              }
            });
          }
        }
      }
    }
  }, 50);

  // 通过按下的区域判定即将拖拽的类型
  // 拖拽分为 1 拖拽创建 dragCreate 2 dragBlockEdit 3 dragBorderEdit
  const handleMouseDown = (
    e: any,
    dragType: number,
    curMoveSchedule?: Schedule | null,
    dragDom?: any
  ) => {
    try {
      const event = e || window.event; // 解决浏览器兼容问题
      if (event.button !== 0) return;
      pauseEvent(event);
      if (dragType === DragType.DRAGBLOCKEDIT && !curMoveSchedule) return;
      let container: any = document.getElementById("calendar-dayview-container-content");
      if (!container) return;
      handleMouseDownFun({
        event,
        dataRef,
        scrollRef,
        container,
        dragType,
        current,
        curMoveSchedule,
        dragDom
      });
    } catch (error) {
      FocusSDK.printLog("dv hmd--->>>", error.message?.toString());
    }
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    // console.log("current", current);
    dataRef.current.curDayStartTime = dayjs(dayjs(current.format("YYYY-MM-DD")).valueOf());
  };
  // 拖拽分为 1 拖拽创建 dragCreate 2 dragBlockEdit 3 dragBorderEdit
  const handleMouseMove = throttle((e: any) => {
    try {
      bus.emit("calendar:scheduleItem:disableClick", true);
      const { curDragType, curMoveSchedule } = dataRef.current;
      if (curDragType === DragType.DRAGBLOCKEDIT && curMoveSchedule) {
        const isCalendarAgent = curMoveSchedule.isCalendarAgent === Agent.AgentAllowed;
        const isCreator = userData?.userId === curMoveSchedule.userId;
        if (!((isCalendarAgent || isCreator) && curMoveSchedule.archive !== 0)) {
          // move同一个元素的时候容易产生多个提示 通过key值去重又容易引起message不消失问题
          // ant 4.2的版本没有根据key值destroy的方法 所以通过hasMessage去重
          if (hasMessage.current) return;
          hasMessage.current = true;
          return message.warning(t("no permission to modify the schedule")).then(
            () => {
              hasMessage.current = false;
              return;
            },
            () => {
              hasMessage.current = false;
              return;
            }
          );
        }
      }
      const event = e || window.event; // 解决浏览器兼容问题
      pauseEvent(event);
      handleMouseMoveFun({
        event,
        dataRef,
        scrollRef,
        dragView: DragViewType.DAY,
        updateDragTime
      });
    } catch (error) {
      FocusSDK.printLog("dv hmm--->>>", error.message?.toString());
    }
  }, 20);
  const handleMouseUp = useCallback(
    (e: any) => {
      const { curDragType, curMoveSchedule } = dataRef.current;
      if (curDragType === DragType.DRAGCREATE) {
        analysisLog("xtbg_calhome_1640073907694", "67");
      } else if (curDragType === DragType.DRAGBLOCKEDIT && curMoveSchedule) {
        analysisLog("xtbg_calhome_1640073907694", "68");
      }
      try {
        bus.emit("calendar:scheduleItem:disableClick", false);
        const event = e || window.event; // 解决浏览器兼容问题
        pauseEvent(event);
        handleMouseUpFun({
          event,
          dataRef,
          dragView: DragViewType.DAY,
          updateDragTime,
          setQuickCreateModalVisible,
          throttleHandleDragElementResize
        });
      } catch (error) {
        FocusSDK.printLog("dv hmu--->>>", error.message?.toString());
      }
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    },
    [handleMouseMove, throttleHandleDragElementResize, updateDragTime]
  );
  const handleDoubleClick = (e: any) => {
    // console.log("dataRef");
    let { minHeight, container } = dataRef.current;
    let box = document.getElementById("drag-box");
    if (!box) {
      // 创建div
      let div = document.createElement("div");
      div.style.height = minHeight + "px";
      div.style.top = dataRef.current.dragStartTop + "px";
      div.id = "drag-box";
      // 绝对定位
      div.style.position = "absolute";
      div.style.cursor = "row-resize";
      // 将创建的div添加到容器中
      container.appendChild(div);
      dataRef.current.dragDivHeight = minHeight;
      // updateDragDivHeightState(minHeight);
      if (!document.getElementById("drag-silk")) {
        let silk = document.createElement("div");
        silk.id = "drag-silk";
        container?.appendChild(silk);
      }
      handleMouseUp(e);
    }
  };
  const handleScrollFrame = (e: any) => {
    try {
      const event = e || window.event; // 解决浏览器兼容问题
      pauseEvent(event);
      handleScrollFrameFun({
        event,
        dataRef,
        scrollRef,
        updateDragTime
      });
    } catch (error) {
      FocusSDK.printLog("dv hsf--->>>", error.message?.toString());
    }
  };
  useEffect(() => {
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [handleMouseMove, handleMouseUp]);
  const content = getComputedElements({ list, current });
  return (
    <div className="calendar-dayview">
      {!!alldayList.length && (
        <DayViewAlldayComp list={alldayList} current={current} myCalendar={myCalendar} />
      )}
      <ScrollView
        // onScroll={onScroll}
        onScrollFrame={handleScrollFrame}
        ref={scrollRef}
        className="scroll-view"
        autoHide
        renderTrackVertical={() => (
          <div
            style={{
              position: "absolute",
              width: "8px",
              transition: "opacity 200ms ease 0s",
              opacity: "0",
              right: "2px",
              bottom: "2px",
              top: "2px",
              borderRadius: "3px"
            }}
          />
        )}
        renderTrackHorizontal={() => (
          <div
            style={{
              height: "0px"
            }}
          />
        )}
      >
        <div
          className="calendar-dayview-container"
          ref={divEl}
          // onDoubleClick={(e) => {
          //   if (document.getElementById("drag-box")) return;
          //   analysisLog("xtbg_calhome_1640073907694", "26");
          //   handleViewClick(e);
          // }}
        >
          <div
            className="calendar-dayview-container-content"
            id="calendar-dayview-container-content"
            onMouseDown={(e) => handleMouseDown(e, DragType.DRAGCREATE)}
            onDoubleClick={(e) => {
              e.persist();
              if (document.getElementById("drag-box")) return;
              analysisLog("xtbg_calhome_1640073907694", "47");
              handleDoubleClick(e);
            }}
          >
            {TimeLine(1, 60, current, currentTimeObj)}
            <div className="calendar-dayview-container-content-scheduleView">
              {content.map(({ schedule, styles, current }, index) => {
                if (schedule.dataType === "task") {
                  return (
                    <ViewTaskItem
                      key={schedule.taskId + schedule.userId + index}
                      schedule={schedule}
                      styles={styles}
                      currentTime={current}
                    />
                  );
                } else {
                  return (
                    <ViewScheduleItem
                      key={schedule.scheduleId + schedule.calendarId + schedule.userId + index}
                      schedule={schedule}
                      styles={styles}
                      currentTime={current}
                      doubleModifySchedule={doubleModifySchedule}
                      handleMouseDown={handleMouseDown}
                    />
                  );
                }
              })}
              {current.isToday() && <CurrentLine current={current} top={currentTimeObj.top} />}
            </div>
          </div>
        </div>
      </ScrollView>
      {/* <ScaleComp /> */}
      <QuickCreateModal
        visible={quickCreateModalVisible ? true : false}
        mask={false}
        maskClosable={true}
        title={dragCreateTitle}
        beginTime={dragCreateBeginTime}
        endTime={dragCreateEndTime}
        onBeginTimeChange={(time: any) => {
          if (quickCreateModalVisible === 1) {
            analysisLog("xtbg_calhome_1640073907694", "52");
          } else if (quickCreateModalVisible === 2) {
            analysisLog("xtbg_calhome_1640073907694", "48");
          }
          setDragCreateBeginTime(time);
        }}
        onEndTimeChange={(time: any) => {
          if (quickCreateModalVisible === 1) {
            analysisLog("xtbg_calhome_1640073907694", "52");
          } else if (quickCreateModalVisible === 2) {
            analysisLog("xtbg_calhome_1640073907694", "48");
          }
          setDragCreateEndTime(time);
        }}
        onDragCreateTitleChange={setDragCreateTitle}
        t={t}
        style={{
          top: quickCreateModalTop,
          left: quickCreateModalLeft
        }}
        onOk={async () => {
          if (dragCreateTitle.length <= 0) {
            message.destroy();
            message.warning("日程标题不能为空！");
            return;
          }
          if (quickCreateModalVisible === 1) {
            analysisLog("xtbg_calhome_1640073907694", "54");
          } else if (quickCreateModalVisible === 2) {
            analysisLog("xtbg_calhome_1640073907694", "50");
          }
          const scheduleData: any = {
            title: dragCreateTitle.trim(),
            beginTime: dragCreateBeginTime?.valueOf(),
            endTime: dragCreateEndTime?.valueOf(),
            user: {
              teamId: userData?.team?.teamId,
              userId: userData?.userId
            },
            remind: "-0,-15",
            color: scheduleTypeList[2].color,
            repeat: 0,
            repeatBeginTime: dragCreateBeginTime?.valueOf(),
            repeatEndTime: null,
            description: "",
            remark: "",
            address: "",
            isAlldate: 0,
            groupId: "",
            calendarId: myCalendar.calendarId,
            participant: [],
            // TODO: 创建人 ownerUser
            content: "",
            attachment: [],
            ddAppId: userData.teamUserInfo.ddAppId
          };
          const [data, err]: any = await addSchedule(scheduleData);
          if (err) {
            message.error(err.message || err);
            resetDragData();
            return;
          }
          if (data.scheduleId) {
            reloadSchedule();
          }
          resetDragData();
          setDragCreateTitle("");
          message.success(t("created-successfully"));
        }}
        onMore={() => {
          if (quickCreateModalVisible === 1) {
            analysisLog("xtbg_calhome_1640073907694", "53");
          } else if (quickCreateModalVisible === 2) {
            analysisLog("xtbg_calhome_1640073907694", "49");
          }
          resetDragData();
          openCreateModal({
            beginTime: dragCreateBeginTime,
            visible: true,
            // 不使用快捷创建
            quickCreate: false,
            endTime: dragCreateEndTime,
            title: dragCreateTitle,
            createModalFrom: 1
          });
          setDragCreateTitle("");
        }}
        onCancel={() => {
          resetDragData();
          setDragCreateTitle("");
        }}
      />
      <BasicModal
        title={t("remind")}
        centered={true}
        visible={dragModifySchedule.modalVisible}
        className="schedule-change-confirm-modal"
        onCancel={() => resetDragData()}
        footer={
          <div className="footer df">
            <BaseButton
              size="small"
              type="primary"
              onClick={() =>
                // 修改日程分为双击普通修改 和 拖拽快捷修改
                quickModifySchedule(
                  dragModifySchedule.triggerType,
                  ModifyType.RepeatOne,
                  dragModifySchedule.modifyBeginTime,
                  dragModifySchedule.modifyEndTime
                )
              }
              clstag="pageclick|keycount|xtbg_calhome_1640073907694|12"
            >
              {t("only-this-schedule")}
            </BaseButton>
            <BaseButton
              size="small"
              className="ml24"
              type="primary"
              onClick={() =>
                quickModifySchedule(
                  dragModifySchedule.triggerType,
                  ModifyType.RepeatFromNow,
                  dragModifySchedule.modifyBeginTime,
                  dragModifySchedule.modifyEndTime
                )
              }
              clstag="pageclick|keycount|xtbg_calhome_1640073907694|13"
            >
              {t("every-after")}
            </BaseButton>
          </div>
        }
      >
        <p>{t("repeat-schedule-change-remind")}</p>
      </BasicModal>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DayView);
